import { useDispatch } from "react-redux";
import { store } from 'Store';
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { http } from "Utils";
import { httpDownload } from "Utils/httpDownload";
import DatatableBase from "Components/Datatable/DatatableBase";
import { Datatable_Column } from "Components/Datatable/DatatableComponents/DatatableColumn";
import { TextButton } from "Components/Button";
import { ERROR_MESSAGES } from "Utils/constants";
import { setGlobalErrorStatus } from 'Components/StatusHandling'
import { Row, Col, Card } from "react-bootstrap";
import RenderSortIcon from "Components/Datatable/RenderSortIcon";
import { TableIconTextButton } from "Components/Button";
import { ICONS } from "Utils/icons";

const AltBatchDetail = () => {
  const loginState = store.getState().loginInfo;
  const location = useLocation();
  const navigate = useNavigate();
  const passedData = location.state;
  const altBatchId = passedData.id;
  const tabKey = passedData.tabKey;
  const [isLoading, setIsLoading] = useState(true);
  const [batchInfo, setBatchInfo] = useState({});
  const dispatch = useDispatch();
  const [backRedirect, setBackRedirect] = useState(passedData.backRedirect);

  const batchFileInfoSearchFieldText = "Search by File Name";
  const batchFileInfoHeader = "Batch File Information";
  // default sorting column
  const batchFileInfoSortId = 'originalFileName';
  const cdaBatchFileInfoSortId = 'name';
  const batchFileInfoSortOrder = 'desc';

  const getBatchDetailInfo = async () => {

    const url = "/api/alt/displayAltBatchDetail/" + altBatchId;
    const body = { "altBatchId": altBatchId };

    const res = await http.post(url, body, {
      headers: {
        "Authorization": "Bearer " + loginState.token
      }
    }).then((res) => {
      //console.log("getBatchDetailInfo", res);
      if (res.status !== 1) {
        setGlobalErrorStatus({
          dispatch: dispatch,
          popupData: {
            visible: true,
            title: ERROR_MESSAGES.DATA_ERROR.title,
            msg: res.globalErrorMessageList[0],
            showContactHelp: true
          },
          redirect: {
            redirect: false,
            redirectFirst: false,
            path: "",
            data: {}
          }
        });
      }
      else {
        var d = res.data;
        setBatchInfo(res.data);

      }
      setIsLoading(false);

    }).catch((error) => {
      //console.log("error getBatchDetailInfo()", error);
      setIsLoading(false);
      setGlobalErrorStatus({
        dispatch: dispatch,
        popupData: {
          visible: true,
          title: ERROR_MESSAGES.DATA_ERROR.title,
          msg: ERROR_MESSAGES.DATA_ERROR.message,
          showContactHelp: true
        },
        redirect: {
          redirect: false,
          redirectFirst: false,
          path: "",
          data: {}
        },
        error: error
      });
    });
  }

  useEffect(() => {
    getBatchDetailInfo();
    window.scrollTo(0, 0);
  }, [])

  // render batch info
  const BatchInfoField = ({ name, value }) => {
    return (
      <div className="info-field-row" key={name + value}>
        <Col sm={4} lg={4}>
          <p className="name w-auto">{name}</p>
        </Col>
        <Col sm={7} lg={7}>
          <p className="value w-auto">{value}</p>
        </Col>
      </div>
    )
  }

  const convertBooleanToText = (value) => {
    if (value == 1) {
      return "Yes";
    }
    else {
      return "No";
    }
  }

  // api to get batch file info
  const getBatchFileInfo = async (filter) => {
    var call = {
      paginationRequest: filter,
      altBatchId: altBatchId
    }

    var url = '/api/alt/getAltBatchFiles';

    return http.post(url, call, {
      headers: {
        "Authorization": "Bearer " + loginState.token
      }
    });
  }

  const getListCols = (selectedList, sortingInfo) => {
    //console.log("getListCols", sortingInfo);
    const listColumns = [];

    listColumns.push(Datatable_Column({ name: "Original File Name", columnName: "originalFileName", selectedRows: selectedList, sortable: true, sortFieldNum: 0, sortingInfo: sortingInfo }));
    listColumns.push(Datatable_Column({ name: "Generated File Name", columnName: "generatedFileName", selectedRows: selectedList, sortable: true, sortFieldNum: 1, sortingInfo: sortingInfo }));
    listColumns.push(Datatable_Column({ name: "File Status", columnName: "fileStatus.description", selectedRows: selectedList, sortable: true, sortFieldNum: 2, sortingInfo: sortingInfo }));

    return listColumns;
  }

  const getCDAListCols = (selectedList, sortingInfo) => {
    //console.log("getCDAListCols", sortingInfo);
    const listColumns = [];

    listColumns.push(Datatable_Column({ name: "Common Format", columnName: "timePeriod.timePrdCd", selectedRows: selectedList, sortable: true, sortFieldNum: 0, sortingInfo: sortingInfo }))
    /**
     * File can be downloaded when it has file content and not related with Deletion
     * File Status:
     * 13: DELETION_INPROGRESS
     * 14: DELETED
     * */
    listColumns.push({
      id: "name",
      name:
        <div className="datatable-col-name">
          File Name
          <div className="dataTableSortIcon">
            <RenderSortIcon sortDirection={sortingInfo.sortingColumn == "name" ? sortingInfo.sortingOrder : ""} />
          </div>
        </div>,
      selector: row => {
        if (row.hasFileData == 1 && row.status.id != 13 && row.status.id != 14) {
          return (
            <div className="non-link-table-cell-data is-button is-break-all">
              <TableIconTextButton onClick={() => handleFileDownload(row.id, row.name)} className="table-action" variant="table"
                title={row.name} icon={ICONS.download}
                content={row.name}
              >
              </TableIconTextButton>
            </div>
          )
        }
        return (
          <span>{row.name}</span>
        )
      },
      sortable: true,
      sortField: 1,
      sortColumnName: 'name',
    });
    listColumns.push(Datatable_Column({ name: "File Status", columnName: "status.description", selectedRows: selectedList, sortable: true, sortFieldNum: 2, sortingInfo: sortingInfo }))
    listColumns.push(Datatable_Column({ name: "Is Same CF Resubmission", columnName: "isResubmission", selectedRows: selectedList, sortable: true, sortFieldNum: 3, formatFunction: convertBooleanToText, sortingInfo: sortingInfo }))
    listColumns.push(Datatable_Column({ name: "Is Cross CF Resubmission", columnName: "isCrossCFResubmission", selectedRows: selectedList, sortable: true, sortFieldNum: 4, formatFunction: convertBooleanToText, sortingInfo: sortingInfo }))

    return listColumns;
  }



  const handleFileDownload = async (fileId, fileName) => {

    const res = await submitDownload(fileId);
    //console.log("after handleFileDownload", res);

    if (res) {

      let url = window.URL.createObjectURL(res.data);
      let a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a); // append the element to the dom
      a.click();
      a.remove(); // afterwards, remove the element  
    }
  }

  const handleAltFileDownload = async (batchInfo, convertedFileFlag) => {

    const res = await submitAltFileDownload(batchInfo.altBatchId, convertedFileFlag);
    //console.log("after handleFileDownload", res);

    if (res) {

      let url = window.URL.createObjectURL(res.data);
      let a = document.createElement('a');
      a.href = url;
      a.download = convertedFileFlag === "No" ? batchInfo.altBatchFileName: "ALT_"+batchInfo.altBatchId+"_Converted_File.zip";
      document.body.appendChild(a); // append the element to the dom
      a.click();
      a.remove(); // afterwards, remove the element  
    }
  }

  const submitDownload = async (fileId) => {
    const call = {
      fileId: fileId
    }

    const url = '/api/cda/downloadXMLFile';

    return httpDownload.post(url, call, {
      responseType: "blob",
      headers: {
        "Authorization": "Bearer " + loginState.token,
      },
    }).catch((error) => {
      //console.log("error handleFileDownload()", error);
      setGlobalErrorStatus({
        dispatch: dispatch,
        popupData: {
          visible: true,
          title: ERROR_MESSAGES.DATA_ERROR.title,
          msg: ERROR_MESSAGES.DATA_ERROR.message,
          showContactHelp: true
        },
        redirect: {
          redirect: false,
          redirectFirst: false,
          path: "",
          data: {}
        },
        error: error
      });
    });
  }

  const submitAltFileDownload = async (altBatchId, convertedFileContentFlag) => {
    const call = {
      altBatchId: altBatchId,
      convertedFileContentFlag: convertedFileContentFlag
    }

    const url = '/api/alt/downloadAltFile';

    return httpDownload.post(url, call, {
      responseType: "blob",
      headers: {
        "Authorization": "Bearer " + loginState.token,
      },
    }).catch((error) => {
      //console.log("error handleFileDownload()", error);
      setGlobalErrorStatus({
        dispatch: dispatch,
        popupData: {
          visible: true,
          title: ERROR_MESSAGES.DATA_ERROR.title,
          msg: ERROR_MESSAGES.DATA_ERROR.message,
          showContactHelp: true
        },
        redirect: {
          redirect: false,
          redirectFirst: false,
          path: "",
          data: {}
        },
        error: error
      });
    });;
  }

  // api to get CDA batch file info
  const getCDABatchFileInfo = async (filter) => {
    var call = {
      paginationRequest: filter,
      //batchId: pseBatchId
      batchId: batchInfo.pseBatchId
    }

    var url = '/api/cda/batchFileInfo';

    return http.post(url, call, {
      headers: {
        "Authorization": "Bearer " + loginState.token
      }
    });
  }

  // navigate back to Alt data Submission
  const backToAltSubmission = (batchInfo) => {

    if (backRedirect == null) {
      // navigate with previous tab selections: "Test" or "Prod"; "In Progress" or "Completed"
      navigate("/data/alternate",
        {
          state: {
            tabKey: tabKey,
            envKey: batchInfo?.sumitType === "T" ? "altTest" : "altProd"
          }
        }
      );
    }
    else {
      navigate(
        backRedirect.path != null ? backRedirect.path : "/data/alternate",
        { state: backRedirect.state }
      );
    }
  }

  return (
    <Row>{isLoading == false ?
      <Col xl={11} lg={11} md={11} sm={12}>
        <Card className="p-4">
          <Card.Body className="text-start">
            <h1 id="mainContent" className="header1 text-start mb-3 blue bold">
              View Alternate
              {batchInfo.batchDetail?.testCase === "Y" ? " Test " : " "}
              {batchInfo.batchDetail?.testCase === "N" ? " Production " : " "}
              Batch Details
            </h1>
            <h2 className="text-start mb-3 form-title">Alternate Batch Information</h2>
            <Col className="mb-5" >
              <div className="info-container">
                <BatchInfoField name={"Alt Batch ID"} value={batchInfo.altBatchId}></BatchInfoField>
                <BatchInfoField name={"CF Version"} value={batchInfo.cfVersionName}></BatchInfoField>
                <BatchInfoField name={"Submission Type"} value={batchInfo.submissionType}></BatchInfoField>
                <BatchInfoField name={"User Name"} value={batchInfo.userName}></BatchInfoField>
                <BatchInfoField name={"PSO ID - Name"} value={batchInfo.psoIdName}></BatchInfoField>
                {batchInfo.vendorIdName ?
                  <BatchInfoField name={"Vendor ID - Name"} value={batchInfo.vendorIdName}></BatchInfoField>
                  :
                  null
                }
                <BatchInfoField name={"Submission Date"} value={batchInfo.submissionDate}></BatchInfoField>
                <BatchInfoField name={"Alt Batch Status"} value={batchInfo.altBatchStatus}></BatchInfoField>
                <BatchInfoField name={"No. Of Files"} value={batchInfo.batchFileCount}></BatchInfoField>
                <BatchInfoField name={"No. Of Accepted"} value={batchInfo.acceptedCount}></BatchInfoField>
                <BatchInfoField name={"No. Of Rejected"} value={batchInfo.rejectedCount}></BatchInfoField>
                {/** 
                 * File can be downloaded: 
                 * 1 by PSOPPCADMIN 
                 * 2 has file content 
                 * 3 Not related with deletion
                 */}
                {batchInfo.isPsoppcAdmin == true
                  && batchInfo.fileContentFlag !== "No"
                  && batchInfo.altBatchStatusId !== 5
                  && batchInfo.altBatchStatusId !== 6
                  ?
                  <>
                    <div className="info-field-row" key={"File Name" + batchInfo.altBatchFileName}>
                      <Col sm={4} lg={4}>
                        <p className="name w-auto">File Name</p>
                      </Col>
                      <Col sm={7} lg={7}>
                        <p className="valueLink file-download-link" tabIndex={0} onClick={() => handleAltFileDownload(batchInfo, "No")} onKeyDown={(e) => (e.key === "Enter" ? handleAltFileDownload(batchInfo, "No") : ()=>{})}>{batchInfo.altBatchFileName}</p>
                      </Col>
                    </div>
                  </>
                  :
                  <BatchInfoField name={"File Name"} value={batchInfo.altBatchFileName}></BatchInfoField>
                }
                {
                  batchInfo.isPsoppcAdmin == true
                  && batchInfo.convertedFileContentFlag !== "No"
                  && batchInfo.altBatchStatusId !== 5
                  && batchInfo.altBatchStatusId !== 6 &&
                  <>
                    <div className="info-field-row" key={"Converted File Name" + batchInfo.altBatchFileName}>
                      <Col sm={4} lg={4}>
                        <p className="name w-auto">Converted File Name</p>
                      </Col>
                      <Col sm={7} lg={7}>
                        <p className="valueLink file-download-link" tabIndex={0} onClick={() => handleAltFileDownload(batchInfo, "Yes")} onKeyDown={(e) => (e.key === "Enter" ? handleAltFileDownload(batchInfo, "Yes") : ()=>{})}>{"ALT_"+batchInfo.altBatchId+"_Converted_File.zip"}</p>
                      </Col>
                    </div>
                  </>
                }
              </div>
            </Col>
            {batchInfo.batchFileStatusView ?
              <>
                {/** Display PSE Batch Infomation and CDA Batch Files datatable */}
                <h2 className="text-start mb-3 form-title">PSE Batch Information</h2>
                <Col className="mb-5" >
                  <div className="info-container">
                    <BatchInfoField name={"Batch ID"} value={batchInfo.pseBatchId}></BatchInfoField>
                    <BatchInfoField name={"Batch Status"} value={batchInfo.batchFileStatusView.batchStatus}></BatchInfoField>
                    {/*Hospital 1.2: Accepted Full, Partial, Minimum
                      * Others: Accepted
                    */}
                    {batchInfo.cfVersionName === "Hospital 1.2" ?
                      <>
                        <BatchInfoField name={"Accepted Full"} value={batchInfo.batchFileStatusView.fullDataSet}></BatchInfoField>
                        <BatchInfoField name={"Accepted Partial"} value={batchInfo.batchFileStatusView.partialDataSet}></BatchInfoField>
                        <BatchInfoField name={"Accepted Minimum"} value={batchInfo.batchFileStatusView.minimumDataSet}></BatchInfoField>
                      </>
                      :
                      <BatchInfoField name={"Accepted"} value={batchInfo.batchFileStatusView.accepted}></BatchInfoField>
                    }
                    <BatchInfoField name={"Rejected"} value={batchInfo.batchFileStatusView.rejected}></BatchInfoField>
                    <BatchInfoField name={"Same CF Resubmits"} value={batchInfo.batchFileStatusView.sameCFResubmits}></BatchInfoField>
                    <BatchInfoField name={"Cross CF Resubmits"} value={batchInfo.batchFileStatusView.crossCFResubmits}></BatchInfoField>
                  </div>
                </Col>
                <DatatableBase
                  tableClassName="cdaBatchFileInfoTable"
                  getData={getCDABatchFileInfo}
                  getListCols={getCDAListCols}
                  hasSelectableRows={false}
                  searchFieldText={batchFileInfoSearchFieldText}
                  datatableHeader={batchFileInfoHeader}
                  datatableDescription={null}
                  sortingColumn={cdaBatchFileInfoSortId}
                  sortingOrder={batchFileInfoSortOrder}
                >
                </DatatableBase>
              </>
              :
              <>
                {/** Display Alt Batch File datatable */}
                <DatatableBase
                  tableClassName="altBatchFileInfoTable"
                  getData={getBatchFileInfo}
                  getListCols={getListCols}
                  hasSelectableRows={false}
                  searchFieldText={batchFileInfoSearchFieldText}
                  datatableHeader={batchFileInfoHeader}
                  datatableDescription={null}
                  sortingColumn={batchFileInfoSortId}
                  sortingOrder={batchFileInfoSortOrder}
                >
                </DatatableBase>
              </>
            }
            {/* Back Button */}
            <TextButton
              className="float-end mt-5"
              variant="outline"
              onClick={() => backToAltSubmission(batchInfo)}
              content={"Back"}
            >
            </TextButton>
          </Card.Body>
        </Card >
      </Col> : null
    }
    </Row>
  )
}

export default AltBatchDetail;